import { defineMessages } from "react-intl"

export const messages = defineMessages({
    NoPaymentsProcessedTitle: {
        id: "payment_processing.payment_listing.no_payments_processed_title",
        defaultMessage: "Process your first payments"
    },
    NoPaymentsProcessedDescription: {
        id: "payment_processing.payment_listing.no_payments_processed_description",
        defaultMessage: "Your account has now been activated. "
        + "You may start processing online payments from quotes, invoices, orders, "
        + "account statements and add cards on file for all your contacts."
    },


})


// WEBPACK FOOTER //
// ./src/payment-processing/payment-listing/messages.ts